const serverContext = '/nuacare-file-storage-api';

export default {
    AUTH: {
        VALIDATE_USERNAME_AND_PASSWORD: `${serverContext}/auth/validateUserNameAndPassword`,
        LOGIN: `${serverContext}/auth/login`,
        SESSION: `${serverContext}/auth/session`,
        LOGOUT: `${serverContext}/auth/logout`,
    },
    SESSION: {
        GET_CURRENT: `${serverContext}/session/getCurrent`,
    },
    COMMON: {
        CURRENT_SERVER_TIME: `${serverContext}/common/currentServerTime`,
    },
    BRANCH: {
        PAGE: `${serverContext}/rest/v1/branch/page`,
        ADD_OR_UPDATE: `${serverContext}/rest/v1/branch/addOrUpdate`,
        DEACTIVATE: `${serverContext}/rest/v1/branch/deactivate`,
        REACTIVATE: `${serverContext}/rest/v1/branch/reactivate`,
        USER: {
            PAGE: `${serverContext}/rest/v1/branch/user/page`,
            ADD_OR_UPDATE: `${serverContext}/rest/v1/branch/user/addOrUpdate`,
            DEACTIVATE: `${serverContext}/rest/v1/branch/user/deactivate`,
            REACTIVATE: `${serverContext}/rest/v1/branch/user/reactivate`,
            UPDATE_PASSWORD: `${serverContext}/rest/v1/branch/user/updatePassword`,
        },
    },
    TWO_FACTOR_AUTH: {
        GET_SETUP_DATA: `${serverContext}/twoFactorAuth/getSetUpData`,
        ENABLE: `${serverContext}/twoFactorAuth/enable`,
    },
};
